/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import Arrow from 'src/assets/arrow-left-black.svg';
import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  RegularButton,
  ICommonDropdownOption,
  FullScreenLoading,
  OutlinedButton,
} from 'pg-ui-library';
import {
  Container,
  CardContainer,
  HelpForm,
  PageTitle,
  FormInputWrapper,
  NavTextLink,
  ArrowBack,
  HeaderItemLeft,
  ModuleLine,
  SearchLink,
  ReadOnlyDiv,
} from './createStyles';
import { useFormik, FormikErrors } from 'formik';
import * as yup from 'yup';
import { AssignmentApiItem } from 'src/interfaces/invoice';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import InvoiceService from 'src/services/invoice.service';
import WorkWeekDatepicker from 'src/components/work-week-datepicker';
import UploadLink from 'src/components/upload-link';
import { useUpdateExpense } from './mutations/expense.mutation';
import ExpenseService from 'src/services/expense.service';
import { currencySymbol } from 'src/utils/currency';

const commonFieldStyle = {
  width: '100%',
  height: '35px',
  borderRadius: '7px',
  border: '1px solid #ccc',
  paddingTop: '2px',
  paddingBottom: '2px',
  boxSizing: 'border-box',
  fontSize: '1.5rem',
} as const;

interface ExistingAttachment {
  id?: string;
  fileName: string;
  fileUrl?: string;
}

interface ExpenseRow {
  id?: string;
  expenseDate: string;
  category: string;
  amount: string;
  miles: string;
  receipt: File | null;
  details: string;
  existingReceipt?: ExistingAttachment | null;
}

interface ExpenseFormValues {
  workerId?: string;
  assignmentId?: string;
  assignmentName?: string;
  clientId?: string | null;
  clientName?: string | null;
  companyName?: string | null;
  supplierName?: string;
  invoiceNumber?: string;
  jobTitle?: string | null;
  hireType?: string | null;
  invoiceAmount?: string;
  currency: string;
  totalUnits?: string;
  totalHours?: string;
  billRate?: string;
  payRate?: string;
  status?: string;
  attachments: File[];
  approverEmail?: string;
  approverName?: string | null;
  notes?: string;
  weekStart?: string | null | undefined;
  weekEnd: string | null | undefined;
  assignmentStartDate: Date | null;
  assignmentEndDate: Date | null;
  expenses: ExpenseRow[];
  deletedReceiptAttachmentIds: string[];
}

const expenseCategories = [
  { name: '', displayName: 'Select' },
  { name: 'AIRFARE', displayName: 'Airfare' },
  { name: 'LODGING', displayName: 'Lodging' },
  { name: 'MEAL', displayName: 'Meal' },
  { name: 'MATERIALS', displayName: 'Materials' },
  { name: 'MILEAGE', displayName: 'Mileage' },
  { name: 'MOBILE', displayName: 'Mobile Device' },
  { name: 'PARKING', displayName: 'Parking/Toll' },
  { name: 'TRANSPORT', displayName: 'Local Transportation' },
  { name: 'OTHER', displayName: 'Other' },
];

const formatOptionLabel = (date: Date) => {
  const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dayName} ${mm}/${dd}/${yyyy}`;
};

const formatOptionValue = (date: Date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const getWeekDateOptions = (selectedDate: Date, minDate?: Date | null, maxDate?: Date | null) => {
  const current = new Date(selectedDate);
  const day = current.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(current);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(current.getDate() + diffToMonday);

  const normalizedMinDate = minDate ? new Date(minDate) : null;
  const normalizedMaxDate = maxDate ? new Date(maxDate) : null;

  if (normalizedMinDate) {
    normalizedMinDate.setHours(0, 0, 0, 0);
  }

  if (normalizedMaxDate) {
    normalizedMaxDate.setHours(0, 0, 0, 0);
  }

  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + index);
    date.setHours(0, 0, 0, 0);

    return date;
  })
    .filter(date => {
      if (normalizedMinDate && date < normalizedMinDate) return false;
      if (normalizedMaxDate && date > normalizedMaxDate) return false;
      return true;
    })
    .map(date => ({
      key: formatOptionValue(date),
      value: formatOptionValue(date),
      label: formatOptionLabel(date),
    }));
};

const getWorkWeekStartEnd = (date: Date) => {
  const selected = new Date(date);
  const day = selected.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(selected);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(selected.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setHours(23, 59, 59, 999);
  sunday.setDate(monday.getDate() + 6);

  return { monday, sunday };
};

const EditExpense: React.FC = () => {
  const { expenseId = '' } = useParams();
  const navigate = useNavigate();
  const updateExpense = useUpdateExpense();
  const [deletedAttachmentIds, setDeletedAttachmentIds] = useState<string[]>([]);
  const [existingAttachments, setExistingAttachments] = useState<any[]>([]);
  const [deletedReceiptIds, setDeletedReceiptIds] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [contractStartDate, setContractStartDate] = useState<Date | null>(null);
  const [contractEndDate, setContractEndDate] = useState<Date | null>(null);
  const [selectedWorkWeekDate, setSelectedWorkWeekDate] = useState<Date | null>(null);

  const { isFetching: isAssignmentFetching, data: assignmentData } = useQuery(
    ['assignment-list-personnal'],
    async () => {
      const result = await InvoiceService.getAssignmentsPersonalNumber();
      return result?.data?.vw_msd_jd_assignments;
    }
  );

  const { isFetching: isExpenseFetching, data: expenseDetail } = useQuery(
    ['expense-detail', expenseId],
    async () => {
      const result = await ExpenseService.getExpenseById({ expenseId: expenseId });
      return result?.data;
    },
    { enabled: !!expenseId }
  );

  const assignmentOptions: ICommonDropdownOption[] = useMemo(() => {
    if (!assignmentData?.items) return [];

    return assignmentData.items
      .filter((item: AssignmentApiItem) => item.EXPENSES_ENABLED === '1')
      .map((item: AssignmentApiItem) => ({
        key: item.ASSIGNMENT_ID,
        value: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.COMPANY_NAME} (${item.CONTRACT_START_DATE} - ${item.CONTRACT_END_DATE})`,
        label: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.COMPANY_NAME} (${item.CONTRACT_START_DATE} - ${item.CONTRACT_END_DATE})`,
      }));
  }, [assignmentData]);

  const assignmentOptionsWithBlank: ICommonDropdownOption[] = [
    { key: '', label: 'Select', value: '' },
    ...assignmentOptions,
  ];

  const validationSchema = yup.object({
    assignmentId: yup.string().required('Assignment is required'),
    expenses: yup
      .array()
      .of(
        yup.object({
          expenseDate: yup.string().required('Date of Expense is required'),
          category: yup.string().required('Category is required'),
          amount: yup.string().when('category', {
            is: (category: string) => category !== 'MILEAGE',
            then: schema =>
              schema
                .required('Amount is required')
                .matches(/^\d+(\.\d{1,2})?$/, 'Max 2 decimal places allowed')
                .test('is-valid-amount', 'Amount must be greater than 0', value => {
                  if (!value) return false;
                  return Number(value) > 0;
                }),
            otherwise: schema => schema.notRequired(),
          }),

          miles: yup.string().when('category', {
            is: 'MILEAGE',
            then: schema =>
              schema
                .required('Miles is required')
                .matches(/^\d+(\.\d{1,2})?$/, 'Max 2 decimal places allowed')
                .test('is-valid-miles', 'Miles must be greater than 0', value => {
                  if (!value) return false;
                  return Number(value) > 0;
                }),
            otherwise: schema => schema.notRequired(),
          }),
        })
      )
      .min(1, 'At least one expense row is required'),
  });

  const formik = useFormik<ExpenseFormValues>({
    enableReinitialize: true,
    initialValues: {
      workerId: expenseDetail?.employeeId || '',
      assignmentId: expenseDetail?.assignmentId || '',
      assignmentName: expenseDetail?.assignmentName || '',
      clientId: expenseDetail?.clientId || '',
      clientName: expenseDetail?.clientName || '',
      companyName: expenseDetail?.companyName || '',
      supplierName: '',
      invoiceNumber: expenseDetail?.expenseShowId || '',
      jobTitle: expenseDetail?.jobTitle || '',
      hireType: expenseDetail?.hireType || '',
      invoiceAmount: String(expenseDetail?.totalAmount || ''),
      currency: expenseDetail?.currency || '',
      totalUnits: '',
      totalHours: '',
      billRate: '',
      payRate: '',
      status: expenseDetail?.status || 'Draft',
      attachments: [],
      deletedReceiptAttachmentIds: [],
      approverEmail: expenseDetail?.approverEmail || '',
      approverName: expenseDetail?.approverName || '',
      notes: expenseDetail?.notes || '',
      weekStart: expenseDetail?.weekStart || '',
      weekEnd: expenseDetail?.weekEnd || '',
      assignmentStartDate: expenseDetail?.assignmentStartDate || null,
      assignmentEndDate: expenseDetail?.assignmentEndDate || null,
      expenses: expenseDetail?.receipts
        ? expenseDetail?.receipts.map((row: any) => ({
            id: row.id,
            expenseDate: row.expenseDate || '',
            category: row.category || '',
            amount: String(row.amount || ''),
            miles: String(row.miles || ''),
            receipt: null,
            details: row.details || '',
            existingReceipt: row.attachments?.[0]
              ? {
                  id: row.attachments[0].id,
                  fileName: row.attachments[0].attachmentName,
                  fileUrl: row.attachments[0].attachmentUrl,
                }
              : null,
          }))
        : [
            {
              expenseDate: '',
              category: '',
              amount: '',
              miles: '',
              receipt: null,
              details: '',
              existingReceipt: null,
            },
          ],
    },
    validationSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async values => {
      try {
        const formData = new FormData();

        const weekDate = selectedWorkWeekDate || (values.weekStart ? new Date(values.weekStart) : null);

        if (weekDate) {
          const { monday, sunday } = getWorkWeekStartEnd(weekDate);
          formData.append('weekStart', monday.toISOString());
          formData.append('weekEnd', sunday.toISOString());
        } else {
          formData.append('weekStart', '');
          formData.append('weekEnd', '');
        }

        // formData.append('id', id);
        formData.append('assignmentId', values.assignmentId || '');
        formData.append('assignmentName', values.assignmentName || '');
        formData.append('clientId', values.clientId || '');
        formData.append('clientName', values.clientName || '');
        formData.append('companyName', values.companyName || '');
        formData.append('supplierName', values.supplierName || '');
        formData.append('invoiceNumber', values.invoiceNumber || '');
        formData.append('jobTitle', values.jobTitle || '');
        formData.append('hireType', values.hireType || '');
        formData.append('status', values.status || '');
        formData.append('invoiceAmount', values.invoiceAmount || '');
        formData.append('totalUnits', values.totalUnits || '');
        formData.append('totalHours', values.totalHours || '');
        formData.append('billRate', values.billRate || '');
        formData.append('payRate', values.payRate || '');
        formData.append('approverEmail', values.approverEmail || '');
        formData.append('approverName', values.approverName || '');
        formData.append('notes', values.notes || '');
        formData.append('currency', values.currency || '');
        formData.append('deletedExpenseAttachmentIds', JSON.stringify(deletedAttachmentIds));
        formData.append('deletedReceiptIds', JSON.stringify(deletedReceiptIds)); // deleting receipts rows
        formData.append('deletedReceiptAttachmentIds', JSON.stringify(values.deletedReceiptAttachmentIds));

        formData.append(
          'receipts',
          JSON.stringify(
            values.expenses.map(exp => {
              const base = {
                expenseDate: exp.expenseDate,
                category: exp.category,
                ...(exp.details ? { details: exp.details } : {}),
                ...(exp.id ? { id: exp.id } : {}),
              };

              if (exp.category === 'MILEAGE') {
                return {
                  ...base,
                  miles: String(exp.miles),
                };
              }

              return {
                ...base,
                amount: Number(exp.amount),
              };
            })
          )
        );

        values.expenses.forEach((exp, index) => {
          if (exp.receipt) {
            formData.append(`receiptAttachments_${index}`, exp.receipt);
          }
        });

        uploadedFiles.forEach(file => {
          formData.append('expenseAttachments', file);
        });

        await updateExpense.mutateAsync({ id: expenseId, expense: formData });
        navigate('/expenses');
      } catch (error) {
        console.error('Error during updating Expense', error);
      }
    },
  });

  useEffect(() => {
    if (!expenseDetail) return;

    if (expenseDetail.weekEnd) {
      setSelectedWorkWeekDate(new Date(expenseDetail.weekEnd));
    }

    if (expenseDetail.attachments?.length) {
      setExistingAttachments(
        expenseDetail.attachments.map((item: any) => ({
          id: item.id,
          attachmentName: item.attachmentName,
          attachmentUrl: item.attachmentUrl,
        }))
      );
    }

    setContractEndDate(expenseDetail.contractEndDate ? new Date(expenseDetail.contractEndDate) : null);

    setContractStartDate(expenseDetail.contractStartDate ? new Date(expenseDetail.contractStartDate) : null);
  }, [expenseDetail]);

  const handleAssignmentChange = (option: string) => {
    const selected = assignmentData?.items?.find((a: AssignmentApiItem) => a.ASSIGNMENT_ID === option);
    if (!selected) return;

    formik.setValues(prev => ({
      ...prev,
      assignmentId: selected.ASSIGNMENT_ID,
      assignmentName: selected.JOBTITLE,
      workerId: selected.EMPLOYEEID,
      clientId: selected.CLIENTID,
      clientName: selected.CLIENT_NAME,
      companyName: selected.WORKER_PAY_COMPANY,
      supplierName: '',
      jobTitle: selected.JOBTITLE,
      hireType: selected.HIRETYPE,
      billRate: String(selected.BILL_RATE ?? ''),
      payRate: String(selected.PAY_RATE ?? ''),
      approverName: selected.ASSIGNMENT_APPROVER_NAME,
      approverEmail: selected.APPROVER_EMAIL,
      currency: selected.CURRENCY,
    }));
  };

  const addExpenseRow = () => {
    formik.setFieldValue('expenses', [
      ...formik.values.expenses,
      {
        expenseDate: '',
        category: '',
        amount: '',
        receipt: null,
        details: '',
        existingReceipt: null,
      },
    ]);
  };

  const removeExpenseRow = (index: number) => {
    const updated = formik.values.expenses.filter((_, i) => i !== index);
    const removed = formik.values.expenses.filter((_, i) => i === index);

    setDeletedReceiptIds(prev => [...prev, removed[0].id || '']);
    formik.setFieldValue('expenses', updated);
  };

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);

    setUploadedFiles(updatedFiles);

    formik.setFieldValue('attachments', updatedFiles);
  };

  const handleRemoveExistingFile = (index: number, attachment: any) => {
    setDeletedAttachmentIds(prev => [...prev, attachment.id]);

    setExistingAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const handleFiles = (files: File[]) => {
    const updatedFiles = [...uploadedFiles, ...files];

    setUploadedFiles(updatedFiles);

    // Update Formik attachments
    formik.setFieldValue('attachments', updatedFiles);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);

    handleFiles(files);
  };

  const handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const files = Array.from(event.dataTransfer.files || []);

    handleFiles(files);
  };

  const dateOfExpenseOptions: ICommonDropdownOption[] = useMemo(() => {
    if (!selectedWorkWeekDate) {
      return [{ key: '', value: '', label: 'Select day' }];
    }

    return [
      { key: '', value: '', label: 'Select day' },
      ...getWeekDateOptions(selectedWorkWeekDate, formik.values.assignmentStartDate, formik.values.assignmentEndDate),
    ];
  }, [selectedWorkWeekDate, formik.values.assignmentStartDate, formik.values.assignmentEndDate]);

  const isEdit = true;

  return (
    <Container>
      {(isAssignmentFetching || updateExpense.isLoading) && <FullScreenLoading />}

      <SearchLink>
        <Link to="/expenses">Search Expenses</Link>
      </SearchLink>

      <HeaderItemLeft>
        <NavTextLink to={-1 as any}>
          <ArrowBack src={Arrow} />
        </NavTextLink>
        <PageTitle>Edit Expense Sheet</PageTitle>
      </HeaderItemLeft>

      <CardContainer>
        <HelpForm>
          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '20px' }}>
            {isEdit ? (
              <FormInputWrapper>
                <label
                  htmlFor="Assignment"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontSize: '16px',
                    color: '#222247',
                  }}
                >
                  Assignment *
                </label>
                <ReadOnlyDiv role="textbox" aria-readonly="true" title={formik.values?.assignmentName}>
                  {formik.values?.assignmentName || ''}
                </ReadOnlyDiv>
              </FormInputWrapper>
            ) : (
              <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                <CommonDropdown
                  label="Assignment *"
                  id="assignmentId"
                  name="assignmentId"
                  options={assignmentOptions}
                  value={formik.values.assignmentId}
                  setValue={handleAssignmentChange}
                  selectStyle={commonFieldStyle}
                />
                <FormErrorWrap
                  errorMessage={formik.errors.assignmentId as string}
                  visible={!!formik.errors.assignmentId}
                />
              </FormInputWrapper>
            )}

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <WorkWeekDatepicker
                onDateChange={setSelectedWorkWeekDate}
                initialDate={formik.values.weekEnd ? new Date(formik.values.weekEnd) : null}
                isEdit={isEdit}
                // minDate={contractStartDate}
                // maxDate={contractEndDate}
              />
            </FormInputWrapper>
          </ModuleLine>

          {formik.values.expenses.map((expense, index) => {
            const isMileage = formik.values.expenses?.[index]?.category === 'MILEAGE';
            const expenseError = formik.errors.expenses?.[index] as FormikErrors<ExpenseRow> | undefined;
            const amountOrMilesError = isMileage ? expenseError?.miles : expenseError?.amount;
            return (
              <ModuleLine
                key={expense.id || index}
                style={{ display: 'flex', gap: '36px', marginBottom: '20px', alignItems: 'flex-start' }}
              >
                <span style={{ fontSize: '1.6rem', minWidth: '20px' }}>{index + 1}</span>

                <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                  <CommonDropdown
                    label={index === 0 ? 'Date of Expense *' : ''}
                    id={`expenses.${index}.expenseDate`}
                    name={`expenses.${index}.expenseDate`}
                    options={dateOfExpenseOptions}
                    value={expense.expenseDate}
                    setValue={(value: string) => formik.setFieldValue(`expenses.${index}.expenseDate`, value)}
                    selectStyle={commonFieldStyle}
                  />
                  <FormErrorWrap
                    errorMessage={(formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.expenseDate as string}
                    visible={
                      !!(
                        formik.submitCount > 0 &&
                        (formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.expenseDate
                      )
                    }
                  />
                </FormInputWrapper>

                <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                  <CommonDropdown
                    label={index === 0 ? 'Category *' : ''}
                    id={`expenses.${index}.category`}
                    name={`expenses.${index}.category`}
                    options={expenseCategories.map(c => ({
                      key: c.name,
                      value: c.name,
                      label: c.displayName,
                    }))}
                    value={expense.category}
                    setValue={(value: string) => formik.setFieldValue(`expenses.${index}.category`, value)}
                    selectStyle={commonFieldStyle}
                  />
                  <FormErrorWrap
                    errorMessage={(formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.category as string}
                    visible={
                      !!(
                        formik.submitCount > 0 &&
                        (formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.category
                      )
                    }
                  />
                </FormInputWrapper>

                <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
                  <label style={{ display: index === 0 ? 'block' : 'none', marginBottom: '-2px', fontSize: '1.6rem' }}>
                    Amount *
                  </label>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* Currency Symbol OUTSIDE */}
                    <span
                      style={{
                        marginRight: '4px',
                        fontSize: '1.4rem',
                        marginTop: '8px',
                      }}
                    >
                      {formik?.values?.expenses?.[index]?.category === 'MILEAGE'
                        ? ''
                        : currencySymbol(formik?.values?.currency) || '$'}
                    </span>

                    {/* Input */}
                    <CommonInput
                      label=""
                      id={`expenses.${index}.${
                        formik?.values?.expenses?.[index]?.category === 'MILEAGE' ? 'miles' : 'amount'
                      }`}
                      name={`expenses.${index}.${
                        formik?.values?.expenses?.[index]?.category === 'MILEAGE' ? 'miles' : 'amount'
                      }`}
                      placeholder={formik?.values?.expenses?.[index]?.category === 'MILEAGE' ? 'Miles' : 'Money'}
                      value={
                        formik?.values?.expenses?.[index]?.category === 'MILEAGE'
                          ? expense.miles || ''
                          : expense.amount || ''
                      }
                      onChange={event =>
                        formik.setFieldValue(
                          `expenses.${index}.${
                            formik?.values?.expenses?.[index]?.category === 'MILEAGE' ? 'miles' : 'amount'
                          }`,
                          event.target.value
                        )
                      }
                      autoComplete="off"
                      style={commonFieldStyle}
                    />

                    {/* RIGHT: Miles */}
                    <span
                      style={{
                        marginLeft: '4px',
                        fontSize: '1.4rem',
                        marginTop: '8px',
                      }}
                    >
                      {formik.values.expenses[index].category === 'MILEAGE' ? 'Miles' : ''}
                    </span>
                  </div>

                  <FormErrorWrap
                    errorMessage={amountOrMilesError as string}
                    visible={!!(formik.submitCount > 0 && amountOrMilesError)}
                  />
                </FormInputWrapper>

                <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
                  <UploadLink
                    label={index === 0 ? 'Receipt' : ''}
                    actionText="Attach"
                    accept=".png,.jpg,.jpeg,.pdf"
                    existingFile={expense.existingReceipt}
                    onFileSelect={file => {
                      formik.setFieldValue(`expenses.${index}.receipt`, file);
                    }}
                    onRemoveExistingFile={file => {
                      if (file?.id) {
                        formik.setFieldValue(
                          'deletedReceiptAttachmentIds',
                          Array.from(new Set([...formik.values.deletedReceiptAttachmentIds, file.id]))
                        );
                      }

                      formik.setFieldValue(`expenses.${index}.existingReceipt`, null);
                      formik.setFieldValue(`expenses.${index}.receipt`, null);
                    }}
                  />
                </FormInputWrapper>

                <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
                  <CommonInput
                    label={index === 0 ? 'Details' : ''}
                    id={`expenses.${index}.details`}
                    name={`expenses.${index}.details`}
                    placeholder="Describe expense"
                    value={expense.details}
                    onChange={event => formik.setFieldValue(`expenses.${index}.details`, event.target.value)}
                    autoComplete="off"
                    style={commonFieldStyle}
                  />
                </FormInputWrapper>

                <FormInputWrapper style={{ flex: '0 0 auto', marginTop: `${index === 0 ? '20px' : '0'}` }}>
                  {formik.values.expenses.length > 1 ? (
                    <OutlinedButton type="button" onClick={() => removeExpenseRow(index)}>
                      Remove
                    </OutlinedButton>
                  ) : null}
                </FormInputWrapper>
              </ModuleLine>
            );
          })}

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '15px' }}>
            <RegularButton type="button" onClick={addExpenseRow}>
              Add
            </RegularButton>
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '5px', position: 'relative' }}>
            <label
              htmlFor="fileUpload"
              style={{
                display: 'block',
                marginBottom: '5px',
                fontSize: '16px',
                color: '#222247',
              }}
            >
              Attachments
            </label>
            <input
              ref={fileInputRef}
              id="fileUpload"
              name="Attachment"
              type="file"
              style={{
                display: 'none',
              }}
              onChange={handleFileChange}
            />
            <div
              style={{
                width: '100%',
                height: '136px',
                border: '1px solid #ccc',
                borderRadius: '7px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative',
                marginBottom: '0px',
                boxSizing: 'border-box',
              }}
              onClick={handleFileUploadClick}
              onDragOver={event => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onDrop={handleFileDrop}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  font: '18px/27px Biotif',
                }}
              >
                <span
                  style={{
                    color: '#4A4BA9',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Add files
                </span>
                <span
                  style={{
                    color: '#222247',
                    opacity: 0.5,
                  }}
                >
                  Or drop files here
                </span>
              </div>
            </div>
            <FormErrorWrap errorMessage={formik.errors.attachments as string} visible={!!formik.errors.attachments} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '20px' }}>
            <div
              style={{
                width: '55%',
                marginTop: '0px',
                paddingTop: '0px',
                borderRadius: '7px',
              }}
            >
              {uploadedFiles.map((file, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#4A4BA9',
                      textDecoration: 'none',
                      marginRight: '10px',
                      fontSize: '12px',
                    }}
                  >
                    {file?.name}
                  </a>
                  <span
                    onClick={() => handleRemoveFile(index)}
                    style={{
                      color: '#4A4BA9',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>

            {existingAttachments.length > 0 && (
              <div style={{ marginTop: '8px', fontSize: '12px' }}>
                {existingAttachments.map((attachment, index) => (
                  <div
                    key={attachment.attachmentUrl}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}
                  >
                    <a
                      href={attachment.attachmentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', textDecoration: 'none' }}
                    >
                      {attachment.attachmentName}
                    </a>

                    <span
                      onClick={() => handleRemoveExistingFile(index, attachment)}
                      style={{
                        color: '#4A4BA9',
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                    >
                      ✕
                    </span>
                  </div>
                ))}
              </div>
            )}
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <label htmlFor="notes" style={{ display: 'block', marginBottom: '5px' }}>
              Notes
            </label>

            <textarea
              id="notes"
              name="notes"
              placeholder="Notes"
              value={formik.values.notes}
              onChange={event => formik.setFieldValue('notes', event.target.value)}
              style={{
                width: '100%',
                height: '136px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                padding: '10px',
                resize: 'none',
                fontSize: '14px',
                textAlign: 'left',
                verticalAlign: 'top',
              }}
            />
          </FormInputWrapper>

          <FormInputWrapper
            style={{
              flex: '0 0 100%',
              display: 'flex',
              justifyContent: 'flex-start',
              marginBottom: '5px',
              marginTop: '20px',
            }}
          >
            <OutlinedButton type="button" onClick={() => navigate('/expenses')}>
              Cancel
            </OutlinedButton>

            <OutlinedButton
              type="button"
              onClick={async () => {
                await formik.setFieldValue('status', 'Draft');
                formik.submitForm();
              }}
              disabled={formik.isSubmitting || updateExpense.isLoading}
            >
              Draft
            </OutlinedButton>

            <RegularButton
              type="button"
              onClick={async () => {
                await formik.setFieldValue('status', 'Submitted');
                formik.submitForm();
              }}
              disabled={formik.isSubmitting || updateExpense.isLoading}
            >
              Update
            </RegularButton>
          </FormInputWrapper>
        </HelpForm>
      </CardContainer>
    </Container>
  );
};

export default EditExpense;
